import React, { useEffect, useState } from 'react';

type props = {
  initialstatus?: boolean;
  id: string;
  disabled?: boolean;
  setStatus: (data: any) => void;
  register: any;
};

const ToggleButton: React.FunctionComponent<props> = ({
  setStatus,
  id,
  disabled,
  initialstatus,
  register,
}): JSX.Element => {
  const randomid = Math.random().toString();
  const [status, setstatus] = useState<boolean>();
  const { onChange, ...rest } = register;
  useEffect(() => {
    setstatus(initialstatus);
  }, [initialstatus]);

  return (
    <div>
      <div className="grid grid-cols-1 gap-0">
        <div className="duration-400 relative mr-2 inline-block w-16 select-none align-middle transition ease-in">
          <input
            type="checkbox"
            id={randomid}
            className={
              'absolute block cursor-pointer appearance-none rounded-full ' +
              (!status
                ? 'h-8 w-8 border-4 border-gray-100 bg-white'
                : ' toggle-button stacked-bar-green-primary h-6 w-6') +
              'toggle-checkbox'
            }
            checked={status}
            onChange={(e) => {
              if (!disabled) {
                const data = e.target.checked;
                onChange(e);
                setstatus(data);
              }
            }}
            {...rest}
          />
          <label
            htmlFor={randomid}
            className={
              'block h-8 cursor-pointer overflow-hidden rounded-full ' +
              (!status ? ' bg-gray-100' : ' toggle-back-ground') +
              (disabled && ' cursor-not-allowed')
            }
          >
            <span
              className={
                (status ? 'float-left ' : 'float-right ') +
                (disabled && ' cursor-not-allowed') +
                ' px-2 py-1 font-extrabold'
              }
            ></span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default ToggleButton;
